(function () {
	$(document).on('click', "#dob", function () {
		if ( $( "#login-box" ).children( "#ui-datepicker-div" ).length == 0 ) {
			$( "#login-box" ).append($( "#ui-datepicker-div" ));
		}
	});//end #dob click
		
	$(document).on('focus', 'select, input, textarea', function () {
	  $(this).removeClass("highlighted");
	  $(this).addClass("select-focus");
	});

	$(document).on('focus', 'div.highlighted', function () {
		$(this).removeClass("highlighted");
	});

	$(document).on('change', '#newclaim-claimant-gender-male, #newclaim-claimant-gender-female', function () {
		//alert($(this).attr("id"));
		$("#label-claimant-gender-male .glyphicon").removeClass("highlighted");
		$("#label-claimant-gender-female .glyphicon").removeClass("highlighted");
	});
	$(document).on('change', '#insurance-proposal-terms-cond, #newclaim-terms-cond', function () {
		//alert($(this).attr("id"));
		$(this).closest(".checkbox").removeClass("highlighted");
	});

	$(document).on('blur', 'select, input, textarea', function () {
	 $(this).removeClass("select-focus");	
	});
})(); //end (function(){


//fix ie10 not support endsWith function
if (!String.prototype.endsWith){
	String.prototype.endsWith = function(pattern) {
		var d = this.length - pattern.length;
		return d >= 0 && this.lastIndexOf(pattern) === d;
	};
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
	Object.defineProperty(Array.prototype, 'findIndex', {
		value: function(predicate) {
		// 1. Let O be ? ToObject(this value).
		if (this == null) {
			throw new TypeError('"this" is null or not defined');
		}

		var o = Object(this);

		// 2. Let len be ? ToLength(? Get(O, "length")).
		var len = o.length >>> 0;

		// 3. If IsCallable(predicate) is false, throw a TypeError exception.
		if (typeof predicate !== 'function') {
			throw new TypeError('predicate must be a function');
		}

		// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
		var thisArg = arguments[1];

		// 5. Let k be 0.
		var k = 0;

		// 6. Repeat, while k < len
		while (k < len) {
			// a. Let Pk be ! ToString(k).
			// b. Let kValue be ? Get(O, Pk).
			// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
			// d. If testResult is true, return k.
			var kValue = o[k];
			if (predicate.call(thisArg, kValue, k, o)) {
			return k;
			}
			// e. Increase k by 1.
			k++;
		}

		// 7. Return -1.
		return -1;
		}
	});
}

var version_no = '1.22.0.1026';